import { cn } from '../../utils/cn'

export interface StarRatingProps {
  /** 0-5; null renders nothing so an unrated staff member stays quiet. */
  value: number | null
  /** Shows the numeric value next to the stars. */
  showValue?: boolean
  className?: string
}

export function StarRating({ value, showValue = false, className }: StarRatingProps) {
  if (value === null || Number.isNaN(value)) return null
  const rounded = Math.round(value)

  return (
    <span className={cn('inline-flex items-center gap-1', className)}>
      <span className="inline-flex" aria-hidden="true">
        {Array.from({ length: 5 }, (_, i) => (
          <span
            key={i}
            className={cn(
              'material-symbols-outlined text-[16px]',
              i < rounded ? 'filled text-primary' : 'text-outline-variant',
            )}
          >
            star
          </span>
        ))}
      </span>
      <span className="sr-only">{`${value} out of 5 stars`}</span>
      {showValue && <span className="font-body-md text-body-md text-on-surface-variant">{value.toFixed(1)}</span>}
    </span>
  )
}
